<popup-header [dialogRef]="dialogRef" icon="add_circle" [text]="getDialogTitle()"></popup-header>
<div class="add-product-dialog" id="add-product-dialog">
  <form [formGroup]="addProductForm">
    <ng-template #phaseField>
      <div class="form-group">
        <label for="phase" class="form-label">Phase <span style="color: red">*</span></label>
        <ng-select
          [items]="phases"
          formControlName="phase"
          placeholder="Select phase"
        data-cypress="select-Phase"></ng-select>
      </div>
    </ng-template>
    <!-- Logo -->
    <div class="logo-container" (click)="triggerFileUpload()" (keydown.enter)="triggerFileUpload()" (keypress)="handleKeyPress($event)">
      <div class="logo-circle">
        @if (addProductForm.get('logo')?.value) {
          <img [src]="addProductForm.get('logo')?.value" alt="Uploaded Logo" />
        }
        @if (!addProductForm.get('logo')?.value) {
          <span class="upload-text">+</span>
        }
      </div>
      <label for="logo" class="visually-hidden">Upload Logo</label>
      <input type="file" id="logo" #fileInput (change)="onLogoChange($event)" accept="image/*" hidden />
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#content-tab1" type="button" role="tab">
          <span class="material-icons-outlined tab-icon" aria-hidden="true" color="accent"> devices_fold </span>
          Product Details
          @if (isTabProductDetailsInvalid()) {
            <span
              class="material-icons-outlined color_red exclamation-point"
              aria-hidden="true"
              color="accent"
              style="vertical-align: middle"
              matTooltip="Missing required fields"
              >priority_high</span
              >
            }
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" data-bs-toggle="tab" data-bs-target="#content-tab2" type="button" role="tab">
            <span class="material-icons-outlined tab-icon" aria-hidden="true" color="accent"> account_tree </span>
            Organization
            @if (isTabOrganizationInvalid()) {
              <span
                class="material-icons-outlined color_red exclamation-point"
                aria-hidden="true"
                color="accent"
                style="vertical-align: middle"
                matTooltip="Missing required fields"
                >priority_high</span
                >
              }
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link"
              data-bs-toggle="tab"
              data-bs-target="#content-tab3"
              type="button"
              role="tab">
              <span class="material-icons-outlined tab-icon" aria-hidden="true" color="accent"> perm_contact_calendar </span>
              Contacts
              @if (isTabContactsInvalid()) {
                <span
                  class="material-icons-outlined color_red exclamation-point"
                  aria-hidden="true"
                  color="accent"
                  style="vertical-align: middle"
                  matTooltip="Missing required fields"
                  >priority_high</span
                  >
                }
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                [class.disabled]="isLocalProduct"
                data-bs-toggle="tab"
                data-bs-target="#content-tab4"
                type="button"
                role="tab">
                <span class="material-icons-outlined tab-icon" aria-hidden="true" color="accent"> flag </span>
                Milestones
                @if (isTabMilestonesInvalid()) {
                  <span
                    class="material-icons-outlined color_red exclamation-point"
                    aria-hidden="true"
                    color="accent"
                    style="vertical-align: middle"
                    matTooltip="Missing required fields"
                    >priority_high</span
                    >
                  }
                </button>
              </li>
              <li class="nav-item">
                <button
                  class="nav-link"
                  [class.disabled]="isLocalProduct"
                  data-bs-toggle="tab"
                  data-bs-target="#content-tab5"
                  type="button"
                  role="tab">
                  <span class="material-icons-outlined tab-icon" aria-hidden="true" color="accent"> paid </span>
                  Costs
                  @if (isTabCostsInvalid()) {
                    <span
                      class="material-icons-outlined color_red exclamation-point"
                      aria-hidden="true"
                      color="accent"
                      style="vertical-align: middle"
                      matTooltip="Missing required fields"
                      >priority_high</span
                      >
                    }
                  </button>
                </li>
                <li class="nav-item">
                  <button
                    class="nav-link"
                    [class.disabled]="isLocalProduct"
                    data-bs-toggle="tab"
                    data-bs-target="#content-tab6"
                    type="button"
                    role="tab">
                    <span class="material-icons-outlined tab-icon" aria-hidden="true" color="accent"> saved_search </span>
                    Dep. Scope
                  </button>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane show active" id="content-tab1" role="tabpanel">
                  <!-- Product Name -->
                  <div class="form-group">
                    <label for="productName" class="form-label">{{ getNameFieldLabel() }} <span style="color: red">*</span></label>
                    <input type="text" class="form-control" id="productName" formControlName="name" required placeholder="Enter product name" />
                    @if (addProductForm.get('name')?.hasError('productNameExists') && (addProductForm.get('name')?.dirty || addProductForm.get('name')?.touched)) {
                      <div class="error-message">
                        This product name already exists.
                      </div>
                    }
                  </div>

                  <!-- Description -->
                  @if (fieldVisibility.description) {
                    <div class="form-group description-container">
                      <label for="description" class="form-label">Description</label>
                      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                      <ngx-editor
                        class="ngx-editor"
                        [editor]="editor"
                        [disabled]="false"
                        [placeholder]="'Add a description'"
                        [(ngModel)]="description"
                        [ngModelOptions]="{standalone: true}">
                      </ngx-editor>
                    </div>
                  }

                  @if (fieldVisibility.sponsorRequester) {
                    <div class="form-group">
                      <label for="sponsor-requester" class="form-label">
                        Sponsor
                      </label>
                      <app-user-autocomplete
                        [placeholder]="'Select Sponsor'"
                        (userSelected)="onUsersSelected($event, 'Sponsor')"
                        [multiple]="false"
                        [clearable]="true"
                        [initialSelectedUsers]="selectedContacts['Sponsor'] ?? []">
                      </app-user-autocomplete>
                    </div>
                  }

                  <!-- Phase (local products only, the other products have it in the Milestones tab) -->
                  @if (isLocalProduct) {
                    <ng-container *ngTemplateOutlet="phaseField"></ng-container>
                  }

                  @if (fieldVisibility.dataProductDetails) {
                    <div class="form-group">
                      <label for="businessRequirement" class="form-label">Business Requirement</label>
                      <textarea id="businessRequirement" class="form-control" formControlName="businessRequirement" rows="3" placeholder="Add link to sharepoint"></textarea>
                    </div>
                    <div class="form-group">
                      <label for="productRequesters" class="form-label">Requester(s) - Digital Product(s)</label>
                      <ng-select id="productRequesters" [items]="products" bindLabel="name" bindValue="id" [multiple]="true" class="select-control-multiple" formControlName="productRequesters" placeholder="Select digital product requesters"></ng-select>
                    </div>
                    <div class="form-group">
                      <label for="programRequesters" class="form-label">Requester(s) - Digital Program(s)</label>
                      <ng-select id="programRequesters" [items]="programOptions" [multiple]="true" class="select-control-multiple" formControlName="programRequesters" placeholder="Select digital program requesters"></ng-select>
                    </div>
                    <div class="form-group">
                      <label for="typeOfNeed" class="form-label">Type of Need</label>
                      <ng-select id="typeOfNeed" [items]="typeOfNeedOptions" bindLabel="name" bindValue="id" formControlName="typeOfNeed" placeholder="Select type of need"></ng-select>
                    </div>
                    <div class="form-group">
                      <label for="sourceSystem" class="form-label">Source System</label>
                      <ng-select id="sourceSystem" [items]="sourceSystemOptions" formControlName="sourceSystem" placeholder="Select source system"></ng-select>
                    </div>
                    @if (showOtherSourceSystem) {
                      <div class="form-group">
                        <label for="sourceSystemOther" class="form-label">Other Source System</label>
                        <input id="sourceSystemOther" type="text" class="form-control" formControlName="sourceSystemOther" placeholder="Enter source system" />
                      </div>
                    }
                    <div class="form-group">
                      <label for="associatedDataTable" class="form-label">Tables defining the Data Product</label>
                      <input id="associatedDataTable" type="text" class="form-control" formControlName="associatedDataTable" placeholder="Enter the tables defining the data product" />
                    </div>
                  }

                  <!-- Squad Profile -->
                  @if (fieldVisibility.squadProfile) {
                    <div class="form-group">
                      <label for="squadProfile" class="form-label">
                        Squad Profile @if (specialFieldIsRequired['squadProfile']) {
                        <span style="color: red">*</span>
                      }
                    </label>
                    <ng-select [items]="squadProfiles" formControlName="squadProfile" [multiple]="false" placeholder="Select squad profile"></ng-select>
                  </div>
                }

                <!-- Associated Product -->
                @if (fieldVisibility.associatedProduct) {
                  <div class="form-group">
                    <label for="associatedProduct" class="form-label">Associated Product</label>
                    <ng-select
                      [items]="products"
                      formControlName="associatedProductId"
                      bindLabel="name"
                      bindValue="id"
                    placeholder="Select associated product"></ng-select>
                  </div>
                }

                <!-- Jira Key -->
                @if (fieldVisibility.jiraProjectKey) {
                  <div class="form-group">
                    <label for="jiraProjectKey" class="form-label">Jira Key</label>
                    <input type="text" class="form-control" id="jiraProjectKey" formControlName="jiraProjectKey" placeholder="Enter Jira key" />
                  </div>
                }

                <!-- CMDB Key -->
                @if (fieldVisibility.finopsBsName) {
                  <div class="form-group">
                    <label for="finopsBsName" class="form-label">CMDB Key for FinOPS</label>
                    <input type="text" class="form-control" id="finopsBsName" formControlName="finopsBsName" placeholder="Enter CMDB key for FinOPS" />
                  </div>
                }

                <!-- Product Type -->
                @if (fieldVisibility.productType) {
                  <div class="form-group">
                    <label for="productType" class="form-label">Product Type <span style="color: red">*</span></label>
                    <ng-select
                      [items]="productTypeOptions"
                      formControlName="productType"
                      placeholder="Select product type"
                      data-cypress="select-product-type"
                      [clearable]="false">
                    </ng-select>
                  </div>
                }

                <!-- Tags -->
                @if (fieldVisibility.tags) {
                  <div class="form-group">
                    <label for="tags" class="form-label">Flag</label>
                    <div style="display: flex; gap: 24px">
                      <div class="tags-container">
                        <!-- Radio buttons for Make/Buy -->
                        <div class="radio-group">
                          <div class="form-check">
                            <input
                              type="radio"
                              class="form-check-input"
                              id="tag-make"
                              name="makeBuy"
                              value="Make"
                              [checked]="addProductForm.get('tags')?.value?.includes('Make')"
                              (click)="onTagRadioChange('makeBuy', 'Make', $event)"
                              (keydown)="onTagRadioChange('makeBuy', 'Make', $event)" />
                              <label class="form-check-label" for="tag-make">Make</label>
                            </div>
                            <div class="form-check">
                              <input
                                type="radio"
                                class="form-check-input"
                                id="tag-buy"
                                name="makeBuy"
                                value="Buy"
                                [checked]="addProductForm.get('tags')?.value?.includes('Buy')"
                                (click)="onTagRadioChange('makeBuy', 'Buy', $event)"
                                (keydown)="onTagRadioChange('makeBuy', 'Buy', $event)" />
                                <label class="form-check-label" for="tag-buy">Buy</label>
                              </div>
                            </div>
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="tag-new"
                                value="New"
                                [checked]="addProductForm.get('tags')?.value?.includes('New')"
                                (change)="onTagCheckboxChange('New', $event)" />
                                <label class="form-check-label" for="tag-new">New</label>
                              </div>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  id="tag-hold"
                                  value="Hold"
                                  [checked]="addProductForm.get('tags')?.value?.includes('Hold')"
                                  (change)="onTagCheckboxChange('Hold', $event)" />
                                  <label class="form-check-label" for="tag-hold">Hold</label>
                                </div>
                                <!-- Radio buttons for Idea/Poc -->
                                <div class="radio-group">
                                  <div class="form-check">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      id="tag-idea"
                                      name="ideaPoc"
                                      value="Idea"
                                      [checked]="addProductForm.get('tags')?.value?.includes('Idea')"
                                      (click)="onTagRadioChange('ideaPoc', 'Idea', $event)"
                                      (keydown)="onTagRadioChange('ideaPoc', 'Idea', $event)" />
                                      <label class="form-check-label" for="tag-idea">Idea</label>
                                    </div>
                                    <div class="form-check">
                                      <input
                                        type="radio"
                                        class="form-check-input"
                                        id="tag-poc"
                                        name="ideaPoc"
                                        value="Poc"
                                        [checked]="addProductForm.get('tags')?.value?.includes('Poc')"
                                        (click)="onTagRadioChange('ideaPoc', 'Poc', $event)"
                                        (keydown)="onTagRadioChange('ideaPoc', 'Poc', $event)" />
                                        <label class="form-check-label" for="tag-poc">Poc</label>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Show in Search Product -->
                                  <div class="form-group" style="margin-top: 0 !important">
                                    <div class="form-check">
                                      <input type="checkbox" class="form-check-input" formControlName="showInSearchProduct" id="showInSearchProduct" />
                                      <label class="form-check-label" for="showInSearchProduct">Show in Search Product</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }

                            <!-- Maturity -->
                            @if (fieldVisibility.maturity) {
                              <div class="form-group">
                                <label for="maturity">Deployment Maturity</label>
                                <ng-select
                                  [items]="maturityLevels"
                                  formControlName="maturity"
                                  placeholder="Select maturity"
                                  data-cypress="select-maturity"
                                  dropdownPosition="top"
                                  data-cypress="select-maturity">
                                  <ng-template ng-option-tmp let-item="item">
                                    <span style="display: flex; width: 100%; height: 100%" [matTooltip]="item.description" matTooltipPosition="right">{{
                                      item.label
                                    }}</span>
                                  </ng-template>
                                </ng-select>
                              </div>
                            }

                            <!-- Rationalization decision -->
                            @if (fieldVisibility.rationalizationDecision) {
                              <div class="form-group">
                                <label for="rationalizationDecision">Rationalization decision</label>
                                <ng-select
                                  [items]="rationalizationDecisions"
                                  formControlName="rationalizationDecision"
                                  placeholder="Select rationalization decision"
                                  data-cypress="select-rationalization-decision"
                                  dropdownPosition="top">
                                  <ng-template ng-option-tmp let-item="item">
                                    <span style="display: flex; width: 100%; height: 100%" [matTooltip]="item.description" matTooltipPosition="right">{{
                                      item.label
                                    }}</span>
                                  </ng-template>
                                </ng-select>
                              </div>
                            }

                            <!-- Upload Documents - Local Products Only -->
                            @if (fieldVisibility.uploadDocuments) {
                              <div style="margin-top: 12px">
                                <div style="display: flex; gap: 16px">
                                  <!-- Upload Communication Kit -->
                                  <button type="button" class="btn btn-secondary" (click)="triggerCommunicationKitUpload()" data-cypress="upload-communication-kit-btn">
                                    <span class="material-icons-outlined" aria-hidden="true">file_upload</span>
                                    Upload Communication Kit
                                  </button>
                                  <!-- Upload Demo -->
                                  <button type="button" class="btn btn-secondary" (click)="triggerDemoUpload()" data-cypress="upload-demo-btn">
                                    <span class="material-icons-outlined" aria-hidden="true">file_upload</span>
                                    Upload Demo
                                  </button>
                                </div>
                                <!-- File inputs (hidden) -->
                                <label for="communicationKitInput" class="visually-hidden">Upload Communication Kit</label>
                                <input id="communicationKitInput" type="file" #communicationKitInput (change)="onCommunicationKitChange($event)" hidden />
                                <label for="demoInput" class="visually-hidden">Upload Demo</label>
                                <input id="demoInput" type="file" #demoInput (change)="onDemoChange($event)" hidden />
                                <!-- Display uploaded files -->
                                <div class="documents-container">
                                  @if (uploadedCommunicationKits?.length > 0) {
                                    <div style="margin-top: 8px">
                                      <small class="text-muted">Communication Kit files:</small>
                                      <ul style="margin: 4px 0; padding-left: 20px">
                                        @for (file of uploadedCommunicationKits; track file) {
                                          <li style="font-size: 12px">
                                            {{ file.name }}
                                            <button type="button" class="btn btn-link btn-sm p-0 ms-1" (click)="removeCommunicationKit(file)" style="color: red">
                                              <span class="material-icons-outlined" style="font-size: 14px">close</span>
                                            </button>
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                  }
                                  @if (uploadedDemos?.length > 0) {
                                    <div style="margin-top: 8px">
                                      <small class="text-muted">Demo files:</small>
                                      <ul style="margin: 4px 0; padding-left: 20px">
                                        @for (file of uploadedDemos; track file) {
                                          <li style="font-size: 12px">
                                            {{ file.name }}
                                            <button type="button" class="btn btn-link btn-sm p-0 ms-1" (click)="removeDemo(file)" style="color: red">
                                              <span class="material-icons-outlined" style="font-size: 14px">close</span>
                                            </button>
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                  }
                                </div>
                                <!-- Display existing documents (when editing) -->
                                <div class="documents-container">
                                  @if (existingCommunicationKits?.length > 0) {
                                    <div style="margin-top: 8px">
                                      <small class="text-muted">Existing Communication Kit documents:</small>
                                      <ul style="margin: 4px 0; padding-left: 20px">
                                        @for (doc of existingCommunicationKits; track doc) {
                                          <li style="font-size: 12px; color: #6c757d">
                                            {{ doc.urlOrPath?.split("/").pop() || doc.title }}
                                            <button
                                              type="button"
                                              class="btn btn-link btn-sm p-0 ms-1"
                                              (click)="removeExistingCommunicationKit(doc)"
                                              style="color: red"
                                              title="Mark for deletion (will be deleted on save)">
                                              <span class="material-icons-outlined" style="font-size: 14px">delete</span>
                                            </button>
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                  }
                                  @if (existingDemos?.length > 0) {
                                    <div style="margin-top: 8px">
                                      <small class="text-muted">Existing Demo documents:</small>
                                      <ul style="margin: 4px 0; padding-left: 20px">
                                        @for (doc of existingDemos; track doc) {
                                          <li style="font-size: 12px; color: #6c757d">
                                            {{ doc.urlOrPath?.split("/").pop() || doc.title }}
                                            <button
                                              type="button"
                                              class="btn btn-link btn-sm p-0 ms-1"
                                              (click)="removeExistingDemo(doc)"
                                              style="color: red"
                                              title="Mark for deletion (will be deleted on save)">
                                              <span class="material-icons-outlined" style="font-size: 14px">delete</span>
                                            </button>
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                  }
                                </div>
                                <!-- Show documents marked for deletion -->
                                @if (documentsToDelete?.length > 0) {
                                  <div
                                    style="margin-top: 8px; padding: 8px; background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px">
                                    <small><strong>⚠️ Documents marked for deletion (will be deleted on save):</strong></small>
                                    <ul style="margin: 4px 0; padding-left: 20px">
                                      @for (doc of documentsToDelete; track doc) {
                                        <li style="font-size: 12px; color: #856404; text-decoration: line-through">
                                          {{ doc.urlOrPath?.split("/").pop() || doc.title }}
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                }
                              </div>
                            }

                            <!-- Technologies -->
                            @if (fieldVisibility.technologies) {
                              <div style="margin-top: 24px;">
                                <h4>Technologies</h4>
                                <div class="form-check" style="margin-top: 12px;">
                                  <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="tag-ai"
                                    value="Ai"
                                    [checked]="addProductForm.get('tags')?.value?.includes('Ai')"
                                    (change)="onTagCheckboxChange('Ai', $event)" />
                                    <label class="form-check-label" for="tag-ai">Agentic &amp; GenAI</label>
                                  </div>
                                  @if (fieldVisibility.hosting) {
                                    <div class="form-group">
                                      <label for="hosting" class="form-label">Hosting</label>
                                      <ng-select
                                        [items]="hostingOptions"
                                        formControlName="hosting"
                                        placeholder="Select hosting"
                                        data-cypress="select-hosting"
                                        dropdownPosition="top"
                                        [clearable]="true">
                                      </ng-select>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                            <div class="tab-pane" id="content-tab2" role="tabpanel">
                              <!-- Branch -->
                              @if (fieldVisibility.branches) {
                                <div class="form-group">
                                  <label for="branches" class="form-label">Branch <span style="color: red">*</span></label>
                                  <ng-select
                                    class="select-control-multiple"
                                    [items]="selectableBranches"
                                    formControlName="branches"
                                    [multiple]="true"
                                  placeholder="Select branches"></ng-select>
                                </div>
                              }

                              <!-- Value stream -->
                              @if (fieldVisibility.valueStreams) {
                                @for (valueStreamField of valueStreamFields; track valueStreamField) {
                                  <div class="form-group">
                                    <label for="valueStream" class="form-label"
                                      ><strong>{{ valueStreamField.label }} @if (specialFieldIsRequired[valueStreamField.formControlName]) {
                                      <span style="color: red">*</span>
                                    }</strong></label
                                    >
                                    <ng-select
                                      [items]="valueStreamField.items"
                                      [formControlName]="valueStreamField.formControlName"
                                      [multiple]="false"
                                      bindLabel="name"
                                      placeholder="Select value stream"
                                    [attr.data-cypress]="'select-value-stream-' + valueStreamField.branch"></ng-select>
                                  </div>
                                }
                              }

                              <!-- Domain -->
                              @if (fieldVisibility.domain) {
                                <div class="form-group">
                                  <label for="domain">Domain</label>
                                  <ng-select [items]="domains" formControlName="domain" placeholder="Select domain" data-cypress="select-domain"></ng-select>
                                </div>
                              }

                              @if (fieldVisibility.discipline) {
                                <div
                                  class="form-group"
                                  >
                                  <label for="discipline" class="form-label">Discipline</label>
                                  <ng-select
                                    [items]="disciplines[addProductForm.get('domain').value]"
                                    formControlName="discipline"
                                    data-cypress="select-discipline"
                                    [clearable]="true">
                                  </ng-select>
                                </div>
                              }

                              @if (fieldVisibility.process) {
                                <div class="form-group">
                                  <label for="discipline" class="form-label">Process</label>
                                  <ng-select
                                    [items]="process[addProductForm.get('discipline').value]"
                                    formControlName="process"
                                    data-cypress="select-process"
                                    [clearable]="true">
                                  </ng-select>
                                </div>
                              }


                              <!-- Entity Owner -->
                              @if (fieldVisibility.entityOwner) {
                                <div class="form-group">
                                  <label for="entityOwner" class="form-label">Entity Owner @if (specialFieldIsRequired['entityOwner']) {
                                    <span style="color: red">*</span>
                                  }</label>
                                  <ng-select
                                    [items]="entityOwnerOptions"
                                    bindLabel="name"
                                    bindValue="id"
                                    formControlName="entityOwner"
                                    placeholder="Select entity owner"
                                    data-cypress="select-entity-owner"
                                    [clearable]="true">
                                  </ng-select>
                                </div>
                              }

                              <!-- Delivery Center -->
                              @if (fieldVisibility.deliveryCenter) {
                                <div class="form-group">
                                  <label for="deliveryCenter" class="form-label">Delivery Center @if (specialFieldIsRequired['deliveryCenter']) {
                                    <span style="color: red">*</span>
                                  }</label>
                                  <ng-select
                                    [items]="deliveryCenterOptions"
                                    bindLabel="name"
                                    bindValue="id"
                                    formControlName="deliveryCenter"
                                    placeholder="Select delivery center"
                                    data-cypress="select-delivery-center"
                                    [clearable]="true">
                                  </ng-select>
                                </div>
                              }

                              <!-- Program -->
                              @if (fieldVisibility.program) {
                                <div class="form-group">
                                  <label for="program" class="form-label">Program</label>
                                  <ng-select
                                    [items]="programOptions"
                                    formControlName="program"
                                    placeholder="Select program"
                                    data-cypress="select-program"
                                    [clearable]="true"
                                    [readonly]="true">
                                  </ng-select>
                                </div>
                              }

                              @if (fieldVisibility.dataPlatform) {
                                <div class="form-group">
                                  <label for="dataPlatform" class="form-label">Data Platform <span style="color: red">*</span></label>
                                  <ng-select id="dataPlatform" [items]="dataPlatformOptions" formControlName="dataPlatform" placeholder="Select data platform"></ng-select>
                                </div>
                                @if (fieldVisibility.dataProductImplementationSquad) {
                                  <div class="form-group">
                                    <label for="dataProductImplementationSquad" class="form-label">Data Product Implementation Squad</label>
                                    <ng-select id="dataProductImplementationSquad" [items]="dataProductImplementationSquadOptions" bindLabel="name" bindValue="id" formControlName="dataProductImplementationSquad" placeholder="Select data squad"></ng-select>
                                  </div>
                                }
                                @if (fieldVisibility.dataDomains) {
                                  <div class="form-group">
                                    <label for="dataDomains" class="form-label">Data Domain(s) <span style="color: red">*</span></label>
                                    <ng-select id="dataDomains" [items]="dataDomainOptions" bindLabel="label" bindValue="id" [multiple]="true" class="select-control-multiple" formControlName="dataDomains" placeholder="Select data domains"></ng-select>
                                  </div>
                                }
                              }

                              <!-- Enabler -->
                              @if (fieldVisibility.enabler) {
                                <div class="form-group">
                                  <label for="enabler" class="form-label">Enabler@if (isEnablerProductMode) {
                                    <span style="color: red">*</span>
                                  }</label>
                                  <ng-select
                                    [items]="enablers"
                                    formControlName="enabler"
                                    bindLabel="name"
                                    bindValue="id"
                                    placeholder="Select enabler"
                                    data-cypress="select-enabler"
                                    [clearable]="!isEnablerProductMode">
                                  </ng-select>
                                </div>
                              }
                            </div>
                            <div class="tab-pane" id="content-tab3" role="tabpanel">
                              <!-- Assets -->
                              @if (fieldVisibility.assets) {
                                <div
                                  class="form-group"
                                  >
                                  <label for="assets" class="form-label">Assets</label>
                                  <ng-select
                                    class="select-control-multiple"
                                    [items]="assets"
                                    formControlName="assets"
                                    [multiple]="true"
                                    bindLabel="name"
                                    placeholder="Select asset"
                                  data-cypress="select-Assets"></ng-select>
                                </div>
                              }
                              <!-- Pilot asset -->
                              @if (fieldVisibility.pilot) {
                                <div
                                  class="form-group"
                                  >
                                  <label for="pilot">Pilot (Asset) @if (specialFieldIsRequired['pilot']) {
                                    <span style="color: red">*</span>
                                  }</label>
                                  <ng-select
                                    [items]="assets"
                                    bindLabel="name"
                                    formControlName="pilot"
                                    placeholder="Select asset"
                                    [disabled]="data?.id"
                                  data-cypress="select-Pilot"></ng-select>
                                </div>
                              }
                              <!-- Sponsor -->
                              @if (fieldVisibility.sponsors) {
                                <div class="form-group">
                                  <label for="sponsors" class="form-label">Sponsors</label>
                                  <app-user-autocomplete
                                    [placeholder]="'Select Sponsors'"
                                    (userSelected)="onUsersSelected($event, 'Sponsor')"
                                    [multiple]="true"
                                    [clearable]="true"
                                    [initialSelectedUsers]="selectedContacts['Sponsor'] ?? []">
                                  </app-user-autocomplete>
                                </div>
                              }

                              <!-- Product Owner -->
                              @if (fieldVisibility.productOwners) {
                                <div class="form-group product-owners">
                                  <label for="productOwner" class="form-label">
                                    Product Owners @if (specialFieldIsRequired['productOwners']) {
                                    <span style="color: red">*</span>
                                  }
                                </label>
                                <div style="display: flex; align-items: center; justify-content: space-between; gap: 16px">
                                  <app-user-autocomplete
                                    style="width: 100%"
                                    [placeholder]="'Select Product Owner'"
                                    (userSelected)="onUsersSelected($event, 'Product Owner')"
                                    [multiple]="true"
                                    [clearable]="true"
                                    [initialSelectedUsers]="selectedContacts['Product Owner'] ?? []">
                                  </app-user-autocomplete>
                                  <!-- Start: Icon status selector for Product Owner -->
                                  <div class="icon-status-container">
                                    <span
                                      class="icon-status clickable"
                                      [style.color]="getProductOwnerStatusColor(addProductForm.get('productOwnerStatus').value)"
                                      [matMenuTriggerFor]="menuProductOwnerStatus"
                                      [matTooltip]="addProductForm.get('productOwnerStatus').value">
                                      <mat-icon>person</mat-icon>
                                    </span>
                                    <mat-menu #menuProductOwnerStatus="matMenu" class="menu-general-status" xPosition="after" yPosition="below">
                                      <div
                                        class="menu-icon-container"
                                        [matTooltip]="getStatusDescriptionFromColor('green')"
                                        matTooltipPosition="right"
                                        matTooltipClass="dot-tooltip">
                                        <button
                                          class="icon-status"
                                          [ngClass]="{selected: getProductOwnerStatusColor(addProductForm.get('productOwnerStatus').value) === 'green'}"
                                          (click)="changeProductOwnerStatus('PO has changed')"
                                          (keydown)="$event.key == 'Enter' ? changeProductOwnerStatus('PO has changed') : null">
                                          <mat-icon style="color: green">person</mat-icon>
                                        </button>
                                      </div>
                                      <div
                                        class="menu-icon-container"
                                        [matTooltip]="getStatusDescriptionFromColor('orange')"
                                        matTooltipPosition="right"
                                        matTooltipClass="dot-tooltip">
                                        <button
                                          class="icon-status"
                                          [ngClass]="{selected: getProductOwnerStatusColor(addProductForm.get('productOwnerStatus').value) === 'orange'}"
                                          (click)="changeProductOwnerStatus('PO is leaving')"
                                          (keydown)="$event.key == 'Enter' ? changeProductOwnerStatus('PO is leaving') : null">
                                          <mat-icon style="color: orange">person</mat-icon>
                                        </button>
                                      </div>
                                      <div
                                        class="menu-icon-container"
                                        [matTooltip]="getStatusDescriptionFromColor('red')"
                                        matTooltipPosition="right"
                                        matTooltipClass="dot-tooltip">
                                        <button
                                          class="icon-status"
                                          [ngClass]="{selected: getProductOwnerStatusColor(addProductForm.get('productOwnerStatus').value) === 'red'}"
                                          (click)="changeProductOwnerStatus('No PO')"
                                          (keydown)="$event.key == 'Enter' ? changeProductOwnerStatus('No PO') : null">
                                          <mat-icon style="color: red">person</mat-icon>
                                        </button>
                                      </div>
                                      <div
                                        class="menu-icon-container"
                                        [matTooltip]="getStatusDescriptionFromColor('grey')"
                                        matTooltipPosition="right"
                                        matTooltipClass="dot-tooltip">
                                        <button
                                          class="icon-status"
                                          [ngClass]="{selected: getProductOwnerStatusColor(addProductForm.get('productOwnerStatus').value) === 'grey'}"
                                          (click)="changeProductOwnerStatus(null)"
                                          (keydown)="$event.key == 'Enter' ? changeProductOwnerStatus(null) : null">
                                          <mat-icon style="color: grey">person</mat-icon>
                                        </button>
                                      </div>
                                    </mat-menu>
                                  </div>
                                  <!-- End: Icon status selector for Product Owner -->
                                </div>
                              </div>
                            }

                            <!-- Asset Lead / Domain Lead  -->
                            @if (fieldVisibility.assetDomainLeads) {
                              <div class="form-group asset-domain-leads">
                                <label for="assetDomainLeads" class="form-label">Asset Lead / Domain Lead</label>
                                <app-user-autocomplete
                                  [placeholder]="'Select Asset/Domain Lead'"
                                  (userSelected)="onUsersSelected($event, 'Asset / Domain Lead')"
                                  [multiple]="true"
                                  [clearable]="true"
                                  [initialSelectedUsers]="selectedContacts['Asset / Domain Lead'] ?? []">
                                </app-user-autocomplete>
                              </div>
                            }

                            <!-- IT Scaler -->
                            @if (fieldVisibility.itScaler) {
                              <div class="form-group it-scaler">
                                <label for="itScaler" class="form-label">Tech Lead / IT Scaler @if (specialFieldIsRequired['itScaler']) {
                                  <span style="color: red">*</span>
                                }</label>
                                <app-user-autocomplete
                                  [placeholder]="'Select Tech Lead / IT Scaler'"
                                  (userSelected)="onUsersSelected($event, 'Tech Lead / IT Scaler')"
                                  [multiple]="false"
                                  [initialSelectedUsers]="selectedContacts['Tech Lead / IT Scaler'] ?? []">
                                </app-user-autocomplete>
                              </div>
                            }

                            <!-- Change Coordinators -->
                            @if (fieldVisibility.changeCoordinators) {
                              <div class="form-group">
                                <label for="changeCoordinators" class="form-label">Change Coordinators</label>
                                <app-user-autocomplete
                                  [placeholder]="'Select Change Coordinators'"
                                  (userSelected)="onUsersSelected($event, 'Change Coordinator')"
                                  [multiple]="true"
                                  [clearable]="true"
                                  [initialSelectedUsers]="selectedContacts['Change Coordinator'] ?? []">
                                </app-user-autocomplete>
                              </div>
                            }

                            <!-- KeyUsers -->
                            @if (fieldVisibility.keyUsers) {
                              <div class="form-group key-users">
                                <label for="keyUsers" class="form-label">KeyUsers</label>
                                <app-user-autocomplete
                                  [placeholder]="'Select KeyUsers'"
                                  (userSelected)="onUsersSelected($event, 'Key User')"
                                  [multiple]="true"
                                  [clearable]="true"
                                  [initialSelectedUsers]="selectedContacts['Key User'] ?? []">
                                </app-user-autocomplete>
                              </div>
                            }

                            <!-- Dynamic Lead -->
                            @if (fieldVisibility.dynamicLead) {
                              <div class="form-group dynamic-leads">
                                <label for="dynamicLeads" class="form-label">Dynamic Lead</label>
                                <app-user-autocomplete
                                  [placeholder]="'Select Dynamic Lead'"
                                  (userSelected)="onUsersSelected($event, 'Dynamic Lead')"
                                  [multiple]="true"
                                  [clearable]="true"
                                  [initialSelectedUsers]="selectedContacts['Dynamic Lead'] ?? []">
                                </app-user-autocomplete>
                              </div>
                            }

                            <!-- PVM -->
                            @if (fieldVisibility.pvm) {
                              <div class="form-group pvms">
                                <label for="pvms" class="form-label">PVM</label>
                                <app-user-autocomplete
                                  [placeholder]="'Select PVM'"
                                  (userSelected)="onUsersSelected($event, 'PVM')"
                                  [multiple]="true"
                                  [clearable]="true"
                                  [initialSelectedUsers]="selectedContacts['PVM'] ?? []">
                                </app-user-autocomplete>
                              </div>
                            }

                            <!-- UI Designer -->
                            @if (fieldVisibility.uxUiDesigners) {
                              <div class="form-group ui-designers">
                                <label for="uiDesigners" class="form-label">UX / UI Designers</label>
                                <app-user-autocomplete
                                  [placeholder]="'Select UX / UI Designers'"
                                  (userSelected)="onUsersSelected($event, 'UX / UI Designer')"
                                  [multiple]="true"
                                  [clearable]="true"
                                  [initialSelectedUsers]="selectedContacts['UX / UI Designer'] ?? []">
                                </app-user-autocomplete>
                              </div>
                            }

                            <!-- DDO (view-only) -->
                            @if (fieldVisibility.ddo) {
                              <div class="form-group ddos">
                                <label for="ddos" class="form-label">DDO</label>
                                <div>
                                  @if (addProductForm.get('ddo')?.value?.length) {
                                    @for (user of addProductForm.get('ddo').value; track user; let last = $last) {
                                      <span>
                                        {{ user.fullName }}@if (!last) {
                                        <span> & </span>
                                      }
                                    </span>
                                  }
                                } @else {
                                  No Data
                                }
                              </div>
                            </div>
                          }

                          <!-- DSL (view-only) -->
                          @if (fieldVisibility.dsl) {
                            <div class="form-group dsls">
                              <label for="dsls" class="form-label">DSL</label>
                              <div>
                                @if (addProductForm.get('dsl')?.value?.length) {
                                  @for (user of addProductForm.get('dsl').value; track user; let last = $last) {
                                    <span>
                                      {{ user.fullName }}@if (!last) {
                                      <span>& </span>
                                    }
                                  </span>
                                }
                              } @else {
                                No Data
                              }
                            </div>
                          </div>
                        }

                        <!-- SME -->
                        @if (fieldVisibility.sme) {
                          <div class="form-group smes">
                            <label for="smes" class="form-label">SME</label>
                            <app-user-autocomplete
                              [placeholder]="'Select SME'"
                              (userSelected)="onUsersSelected($event, 'SME')"
                              [multiple]="true"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['SME'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }

                        @if (fieldVisibility.dataProductOwner) {
                          <div class="form-group">
                            <label for="data-product-owner" class="form-label">Data Product Owner</label>
                            <app-user-autocomplete
                              [placeholder]="'Select Data Product Owner'"
                              (userSelected)="onUsersSelected($event, 'Data Product Owner')"
                              [multiple]="true"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['Data Product Owner'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }

                        @if (fieldVisibility.dataProductPo) {
                          <div class="form-group">
                            <label for="data-product-po" class="form-label">Data Product PO</label>
                            <app-user-autocomplete
                              [placeholder]="'Select Data Product PO'"
                              (userSelected)="onUsersSelected($event, 'Data Product PO')"
                              [multiple]="false"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['Data Product PO'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }

                        @if (fieldVisibility.dataProductValueManager) {
                          <div class="form-group">
                            <label for="data-product-value-manager" class="form-label">Data Product Value Manager</label>
                            <app-user-autocomplete
                              [placeholder]="'Select Data Product Value Manager'"
                              (userSelected)="onUsersSelected($event, 'Data Product Value Manager')"
                              [multiple]="true"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['Data Product Value Manager'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }

                        @if (fieldVisibility.dataProductTechlead) {
                          <div class="form-group">
                            <label for="data-product-techlead" class="form-label">Data Product Tech Lead</label>
                            <app-user-autocomplete
                              [placeholder]="'Select Data Product Tech Lead'"
                              (userSelected)="onUsersSelected($event, 'Data Product Tech Lead')"
                              [multiple]="true"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['Data Product Tech Lead'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }

                        @if (fieldVisibility.dataProductArchitect) {
                          <div class="form-group">
                            <label for="data-product-architect" class="form-label">Data Product Architect</label>
                            <app-user-autocomplete
                              [placeholder]="'Select Data Product Architect'"
                              (userSelected)="onUsersSelected($event, 'Data Product Architect')"
                              [multiple]="true"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['Data Product Architect'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }

                        @if (fieldVisibility.dataPreparationLead) {
                          <div class="form-group">
                            <label for="data-preparation-lead" class="form-label">Data Preparation Lead</label>
                            <app-user-autocomplete
                              [placeholder]="'Select Data Preparation Lead'"
                              (userSelected)="onUsersSelected($event, 'Data Preparation Lead')"
                              [multiple]="true"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['Data Preparation Lead'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }

                        @if (fieldVisibility.dataProductPortfolioManager) {
                          <div class="form-group">
                            <label for="data-product-portfolio-manager" class="form-label">Data Product Portfolio Manager</label>
                            <app-user-autocomplete
                              [placeholder]="'Select Data Product Portfolio Manager'"
                              (userSelected)="onUsersSelected($event, 'Data Product Portfolio Manager')"
                              [multiple]="true"
                              [clearable]="true"
                              [initialSelectedUsers]="selectedContacts['Data Product Portfolio Manager'] ?? []">
                            </app-user-autocomplete>
                          </div>
                        }
                      </div>
                      <div class="tab-pane" id="content-tab4" role="tabpanel">
                        @if (!isLocalProduct) {
                          <div style="margin-top: 12px">
                            <ng-container *ngTemplateOutlet="phaseField"></ng-container>
                          </div>
                        }

                        @if (isDataProductMode) {
                          <div class="form-group" style="margin-top: 12px">
                            <label for="sandboxStartDate" class="form-label">Sandbox Start Date @if (requiredMilestoneControls.includes('sandboxStartDate')) {
                              <span style="color: red">*</span>
                            }</label>
                            <mat-form-field appearance="outline" class="standardize-datepicker">
                              <input id="sandboxStartDate" matInput [matDatepicker]="sandboxPicker" placeholder="Choose a date" formControlName="sandboxStartDate"/>
                              <mat-datepicker-toggle matIconSuffix [for]="sandboxPicker"></mat-datepicker-toggle>
                              <mat-datepicker #sandboxPicker></mat-datepicker>
                            </mat-form-field>
                          </div>
                        }

                        <!-- Milestones -->
                        <div class="form-group">
                          <div class="milestones-group">
                            @for (period of phasesPeriods; track period; let i = $index) {
                              @if (i % 2 == 0) {
                                <div>
                                  <div class="milestones-phase">
                                    <span class="period-label">{{ period.label }}</span>
                                    <ng-select
                                      placeholder="Select Status"
                                      [id]="period.status"
                                      [items]="statusesNames"
                                      [formControlName]="period.status"
                                      [clearable]="false">
                                      <ng-template ng-option-tmp let-item="item">
                                        <span class="background-item" [style.background-color]="getBackgroundColorOfStatus(item)"
                                        style="color: white;">{{ item }}</span>
                                      </ng-template>
                                      <ng-template ng-label-tmp let-item="item">
                                        <span class="background-item" [style.background-color]="getBackgroundColorOfStatus(item)"
                                        style="color: white;">{{ item }}</span>
                                      </ng-template>
                                    </ng-select>
                                  </div>
                                  <div class="milestones-fields">
                                    <ng-container *ngTemplateOutlet="milestonesField; context: {'period': period, 'type': 'Planned', 'periodIndex': i}"></ng-container>
                                    <ng-container *ngTemplateOutlet="milestonesField; context: {'period': phasesPeriods[i + 1], 'type': 'Realized', 'periodIndex': i + 1}"></ng-container>
                                  </div>
                                  @if (isDataProductMode && i === 6) {
                                    <div class="form-check" style="margin-top: 8px; margin-bottom: 12px">
                                      <input type="checkbox" class="form-check-input" formControlName="publishedInDataMarket" id="publishedInDataMarket" />
                                      <label class="form-check-label" for="publishedInDataMarket">Published in the Data Catalog</label>
                                    </div>
                                  }
                                </div>
                              }
                            }
                            <ng-template #milestonesField let-period="period" let-type="type" let-periodIndex="periodIndex">
                              <div class="milestones-field">
                                <span class="period-label">{{ type }} @if (requiredMilestoneControls.includes(period.start) || requiredMilestoneControls.includes(period.end)) {
                                  <span style="color: red">*</span>
                                }</span>
                                <mat-form-field appearance="outline" class="standardize-datepicker">
                                  <mat-date-range-input [rangePicker]="picker">
                                    <label for="startDate" class="visually-hidden">Start date</label>
                                    <input id="startDate" matStartDate placeholder="Start date" [formControlName]="period.start" (dateChange)="onDateChange(periodIndex)" />
                                    <label for="endDate" class="visually-hidden">End date</label>
                                    <input id="endDate" matEndDate placeholder="End date" [formControlName]="period.end" (dateChange)="onDateChange(periodIndex)" />
                                  </mat-date-range-input>
                                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                </mat-form-field>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                @if (dateError) {
                                  <div class="error-message">
                                    {{ dateError }}
                                  </div>
                                }
                              </div>
                            </ng-template>

                            <!-- Min Deployment Time -->
                            @if (!isDataProductMode) {
                              <div class="form-group min-deployment-time">
                                <label for="minDeploymentTime" class="form-label">Min deployment time in number of sprints :</label>
                                <input type="number" class="form-control" id="minDeploymentTime" formControlName="minDeploymentTime" placeholder="0" />
                                <i>sprint(s)</i>
                              </div>
                            }

                            <!-- Discarded Date -->
                            <div class="status-field">
                              <label for="discardedDate">Discarded Date @if (requiredMilestoneControls.includes('discardedDate')) {
                                <span style="color: red">*</span>
                              }</label>
                              <mat-form-field appearance="outline" class="standardize-datepicker">
                                <input id="discardedDate" matInput [matDatepicker]="discardedPicker" placeholder="Choose a date" formControlName="discardedDate"/>
                                <mat-datepicker-toggle matIconSuffix [for]="discardedPicker"></mat-datepicker-toggle>
                                <mat-datepicker #discardedPicker></mat-datepicker>
                              </mat-form-field>
                            </div>

                            <!-- Decommissioned Date -->
                            <div class="status-field">
                              <label for="decommissionedDate">Decommissioned Date @if (requiredMilestoneControls.includes('decommissionedDate')) {
                                <span style="color: red">*</span>
                              }</label>
                              <mat-form-field appearance="outline" class="standardize-datepicker">
                                <input id="decommissionedDate" matInput [matDatepicker]="decommissionedPicker" placeholder="Choose a date" formControlName="decommissionedDate"/>
                                <mat-datepicker-toggle matIconSuffix [for]="decommissionedPicker"></mat-datepicker-toggle>
                                <mat-datepicker #decommissionedPicker></mat-datepicker>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="content-tab5" role="tabpanel">
                        @if (!isDataProductMode) {
                          <div style="margin-top: 12px;">
                            <h4>2025 RUN COST</h4>
                            <div class="form-group cost-input">
                              <label for="runCostApp" class="form-label" [matTooltip]="'License + Maintenance'">Appli :</label>
                              <input type="number" class="form-control" id="runCostApp" formControlName="runCostApp" placeholder="0"
                                (keydown)="ensureTwoNumberDecimals('runCostApp')" [readonly]="!isAdmin"/>
                                <i>€</i>
                              </div>
                              <div class="form-group cost-input">
                                <label for="runCostInfra" class="form-label">Infra :</label>
                                <input type="number" class="form-control" id="runCostInfra" formControlName="runCostInfra" placeholder="0"
                                  (keydown)="ensureTwoNumberDecimals('runCostInfra')" [readonly]="!isAdmin"/>
                                  <i>€</i>
                                </div>
                                <div class="form-group cost-input">
                                  <label for="globalItRunCost" class="form-label">Global IT Run Cost :</label>
                                  <input type="number" class="form-control" id="globalItRunCost" formControlName="globalItRunCost" placeholder="0"
                                    (keydown)="ensureTwoNumberDecimals('globalItRunCost')" [readonly]="!isAdmin"/>
                                    <i>€</i>
                                  </div>
                                </div>
                                <div style="margin-top: 24px;">
                                  <h4>2025 BUILD COST</h4>
                                  <div class="form-group cost-input">
                                    <label for="buildCostProject" class="form-label">Project :</label>
                                    <input type="number" class="form-control" id="buildCostProject" formControlName="buildCostProject" placeholder="0"
                                      (keydown)="ensureTwoNumberDecimals('buildCostProject')" [readonly]="!isAdmin"/>
                                      <i>€</i>
                                    </div>
                                    <div class="form-group cost-input">
                                      <label for="buildCostEvo" class="form-label">Evo :</label>
                                      <input type="number" class="form-control" id="buildCostEvo" formControlName="buildCostEvo" placeholder="0"
                                        (keydown)="ensureTwoNumberDecimals('buildCostEvo')" [readonly]="!isAdmin"/>
                                        <i>€</i>
                                      </div>
                                      <div style="margin-top: 16px;">
                                        <span class="form-label">Total build : {{addProductForm.get('buildCostProject')?.value + addProductForm.get('buildCostEvo')?.value}} €</span>
                                      </div>
                                    </div>
                                  } @else {
                                    <div style="margin-top: 12px;">
                                      <h4>Estimated Budget/Cost</h4>
                                      <div class="form-group cost-input">
                                        <label for="dataProductPreframingCost" class="form-label">Pre framing :</label>
                                        <input
                                          type="number"
                                          class="form-control"
                                          id="dataProductPreframingCost"
                                          formControlName="dataProductPreframingCost"
                                          placeholder="0"
                                          (keydown)="ensureTwoNumberDecimals('dataProductPreframingCost')"/>
                                          <i>€</i>
                                        </div>
                                        <div class="form-group cost-input">
                                          <label for="dataProductFramingCost" class="form-label">Framing :</label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            id="dataProductFramingCost"
                                            formControlName="dataProductFramingCost"
                                            placeholder="0"
                                            (keydown)="ensureTwoNumberDecimals('dataProductFramingCost')"/>
                                            <i>€</i>
                                          </div>
                                          <div class="form-group cost-input">
                                            <label for="dataProductBuildCost" class="form-label">Build :</label>
                                            <input
                                              type="number"
                                              class="form-control"
                                              id="dataProductBuildCost"
                                              formControlName="dataProductBuildCost"
                                              placeholder="0"
                                              (keydown)="ensureTwoNumberDecimals('dataProductBuildCost')"/>
                                              <i>€</i>
                                            </div>
                                            <div class="form-group cost-input">
                                              <label for="dataProductRunMaintainCost" class="form-label">Annual Run &amp; Maintain :</label>
                                              <input
                                                type="number"
                                                class="form-control"
                                                id="dataProductRunMaintainCost"
                                                formControlName="dataProductRunMaintainCost"
                                                placeholder="0"
                                                (keydown)="ensureTwoNumberDecimals('dataProductRunMaintainCost')"/>
                                                <i>€</i>
                                              </div>
                                            </div>
                                          }

                                        </div>
                                        <div class="tab-pane" id="content-tab6" role="tabpanel">
                                          <div class="dep-scope-container" style="margin-top: 12px;">
                                            @if (addProductForm.get('branches')?.value?.length > 1) {
                                              <div class="segmented-control-container dep-scope-tabs">
                                                @for (branch of getSortedDepScopeBranches(); track branch) {
                                                  <button
                                                    class="segmented-control-item segmented-control-small"
                                                    [ngClass]="{selected: selectedDepScopeBranch === branch}"
                                                    (click)="selectDepScopeBranch(branch)"
                                                    (keydown)="$event.key === 'Enter' ? selectDepScopeBranch(branch) : null">
                                                    {{ branch }}
                                                  </button>
                                                }
                                              </div>
                                            }

                                            @if (assetsByBranchLoading) {
                                              <div class="spinner-container">
                                                <div class="spinner-border text-primary" output="status">
                                                  <span class="visually-hidden">Loading...</span>
                                                </div>
                                              </div>
                                            }

                                            @if (selectedDepScopeBranch) {
                                              <div style="margin-top: 12px;">
                                                <label class="form-label" for="depScopeSearch">Search for BU, LBU, Assets, Sites</label>
                                                <input
                                                  id="depScopeSearch"
                                                  type="text"
                                                  class="form-control"
                                                  [ngModel]="depScopeSearchQuery"
                                                  (ngModelChange)="onDepScopeSearchChange($event)"
                                                  [ngModelOptions]="{standalone: true}"
                                                  placeholder="Search..." />
                                                </div>
                                                <div class="dep-scope-chips">
                                                  @for (chip of selectedChips; track chip) {
                                                    <span class="dep-scope-chip">
                                                      <span class="dep-scope-chip-label">{{ chip.path }}</span>
                                                      <button type="button" class="dep-scope-chip-remove" (click)="removeChip(chip.name)" (keydown.enter)="removeChip(chip.name)">×</button>
                                                    </span>
                                                  }
                                                </div>
                                                <div class="dep-scope-table" style="margin-top: 12px;">
                                                  <div class="dep-scope-row dep-scope-header">
                                                    <div class="dep-scope-cell dep-scope-cell-bu-lbu">BU &gt; LBU &gt; Asset &gt; Site</div>
                                                    <div class="dep-scope-cell dep-scope-cell-select">Select</div>
                                                  </div>
                                                  @for (item of nodesToDisplay; track item; let i = $index) {
                                                    <div class="dep-scope-row">
                                                      <div class="dep-scope-cell dep-scope-cell-main">
                                                        <span class="dep-scope-indent" [style.width.px]="item.depth * 20"></span>
                                                        @if (item.node.children?.length) {
                                                          <button class="dep-scope-collapse-btn"
                                                            (click)="toggleScopeCollapse(item.node)"
                                                            (keydown)="$event.key === 'Enter' ? toggleScopeCollapse(item.node) : null">
                                                            <span class="material-icons-outlined dep-scope-arrow">{{ item.node.collapsed ? 'chevron_right' : 'expand_more' }}</span>
                                                          </button>
                                                        }
                                                        @if (!item.node.children?.length) {
                                                          <span class="dep-scope-no-arrow"></span>
                                                        }
                                                        <span class="dep-scope-name" [class.dep-scope-name-bold]="item.node.children?.length">{{ item.node.name }}</span>
                                                        @if (item.node.children?.length) {
                                                          <span class="dep-scope-leaf-count">
                                                            ({{ item.leafStats.selected }}/{{ item.leafStats.total }} sites selected)
                                                          </span>
                                                        }
                                                      </div>
                                                      <div class="dep-scope-cell dep-scope-cell-select" [attr.data-cypress]="item.node.name">
                                                        <mat-checkbox
                                                          [checked]="item.node.selected === 'yes'"
                                                          [indeterminate]="item.node.selected === 'partial'"
                                                          (change)="toggleScopeSelect(item.node)">
                                                        </mat-checkbox>
                                                      </div>
                                                    </div>
                                                    <!-- Add New Site input for Assets - shown after the last site of each asset -->
                                                    @if (shouldShowAddNewSiteRow(i)) {
                                                      <div class="dep-scope-row dep-scope-add-site-row">
                                                        <div class="dep-scope-cell dep-scope-cell-main">
                                                          <span class="dep-scope-indent" [style.width.px]="60"></span>
                                                          <label for="newSiteName" class="visually-hidden">New Site Name</label>
                                                          <input
                                                            id="newSiteName"
                                                            type="text"
                                                            class="form-control dep-scope-new-site-input"
                                                            [(ngModel)]="newSiteNames[getAssetNodeForAddNewRow(i)?.id]"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="New site name..."
                                                            (keydown.enter)="addNewSite(getAssetNodeForAddNewRow(i))"/>
                                                          </div>
                                                          <div class="dep-scope-cell dep-scope-cell-select">
                                                            <button
                                                              type="button"
                                                              class="btn btn-sm btn-primary dep-scope-add-btn"
                                                              (click)="addNewSite(getAssetNodeForAddNewRow(i))"
                                                              [disabled]="!newSiteNames[getAssetNodeForAddNewRow(i)?.id] || newSiteNames[getAssetNodeForAddNewRow(i)?.id]?.trim() === ''">
                                                              Add New
                                                            </button>
                                                          </div>
                                                        </div>
                                                      }
                                                    }
                                                    @if (nodesToDisplay.length === 0 && depScopeSearchQuery) {
                                                      <div class="dep-scope-empty">
                                                        <span class="text-muted">No results found.</span>
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                          <!-- Submit Button -->
                                          <div class="form-actions">
                                            <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
                                            <!-- Delete button - only visible for local products in edit mode -->
                                            @if (isLocalProduct && data?.product?.id) {
                                              <button
                                                type="button"
                                                class="btn btn-primary"
                                                (click)="deleteProduct(data?.product?.id)"
                                                data-cypress="delete-product">
                                                <span class="material-icons-outlined" style="vertical-align: middle; margin-right: 4px">delete</span>
                                                Delete Product
                                              </button>
                                            }
                                            <span
                                              matTooltip="Required fields are missing. When the phase changes, the Realized dates of the completed phase and the Realized start date of the new phase are mandatory (the Planned dates of the new phase too when creating a product)."
                                              [matTooltipDisabled]="!addProductForm.invalid">
                                              <button type="button" class="btn btn-primary" (click)="onSubmit()"
                                                [disabled]="addProductForm.invalid || (!data?.product?.id && addProductForm.get('name')?.hasError('productNameExists'))"
                                                data-cypress="update-product">
                                                {{ getSubmitButtonLabel() }}
                                              </button>
                                            </span>
                                          </div>
                                        </form>
                                      </div>
